import { z } from 'my-zod'
import { transferModel } from './transfer-model'

export const transferCreate = transferModel
  .pick({
    amount: true,
    currency: true,
    withdrawalDescription: true,
    depositDescription: true,
    source: true,
    destination: true,
    transferGroup: true,
    metadata: true
  })
  .augment({
    reverses: z.onumber(),
    notes: z.string().max(256).nullish()
  })

export type transferCreate = z.infer<typeof transferCreate>

export const reversalCreate = z.object({
  reverses: z.number(),
  amount: z.number().positive().int()
})

export type reversalCreate = z.infer<typeof reversalCreate>
